// The realm's countries (fk-schema `Biome`, `world_clock.biome`), each with its own custom
// overworld art (docs/70). Kept apart from the chart generator so the dev server's Art Studio
// endpoints and the seed script can read it.

export const BIOMES = ['temperate', 'wetland', 'boreal', 'desert', 'highland', 'jungle', 'underdark', 'ashlands'] as const;
export type Biome = (typeof BIOMES)[number];
export const isBiome = (s: string | undefined): s is Biome => (BIOMES as readonly string[]).includes(s ?? '');
/** The custom art a chart in `biome` draws from (a World with no clock yet is temperate, as `overworldKit`'s default). */
export const artBiome = (biome: string | undefined): Biome => (isBiome(biome) ? biome : 'temperate');
